  <div class="main"
       fxLayoutAlign="center center">

    <div class="account-app-bar-expanded"
         fxLayout="row"
         fxLayoutAlign="center center"
         fxHide.xs>

      <div class="chip-container"
           fxLayout="column"
           fxLayoutAlign="start end"
           fxLayoutGap="12px">
        <ifb-bank-account-link-status-icon-chip [status]="data?.application?.bankLinkStatus">
        </ifb-bank-account-link-status-icon-chip>
        <div class="chip-label">Bank link status</div>
      </div>

      <mat-divider class="divider"
                   [vertical]="true">
      </mat-divider>

      <div class="stepper-container">
        <div class="stepper">
          <div class="step"
               [class.step--active]="activeStepNumber > 0">
            <div class="step__icon">1</div>
            <div class="step__label">Application</div>
          </div>
          <mat-divider class="stepper__divider"
                       [class.stepper__divider--active]="activeStepNumber > 1">
          </mat-divider>
          <div class="step"
               [class.step--active]="activeStepNumber > 1">
            <div class="step__icon">2</div>
            <div class="step__label">Underwriting</div>
          </div>
          <mat-divider class="stepper__divider"
                       [class.stepper__divider--active]="activeStepNumber > 2">
          </mat-divider>
          <div class="step"
               [class.step--active]="activeStepNumber > 2">
            <div class="step__icon">3</div>
            <div class="step__label">Decision</div>
          </div>
        </div>
        <div class="info"
             *ngIf="showWarning || showError || showSuccess">
          <mat-icon class="info__icon"
                    [ngClass]="{'mat-orange-bg': showError, 'mat-pink-bg': showWarning, 'mat-green-bg': showSuccess }">
            {{showWarning ? 'warning' : (showSuccess ? 'done' : 'priority_high')}}</mat-icon>
          <div>{{message}}</div>
        </div>
      </div>
    </div>
  </div>

  <router-outlet name="tabs"></router-outlet>
